import React from 'react'
import PropTypes from 'prop-types'

import styles from './style.module.scss'

function CompareList({ data, isSmall, isColored, showTitle }) {
  return (
    <div
      className={`${styles.list} dd common-box flex-grow-1 ${
        isSmall ? 'mb-0 px-2 px-md-0 py-1 mx-md-n2 mt-1 mt-md-0' : 'py-2 px-3 px-md-4'
      }`}
    >
      {isSmall && showTitle && (
        <div className={`d-flex ${isColored ? styles.row : ''} align-items-center ${isSmall ? 'py-1' : 'py-2'}`}>
          <div className={`${styles.item}`}></div>
          <p className={`${styles.label} mb-0 fw-bold px-1 text-center`}>VS</p>
          <div className={`${styles.item} text-end`}></div>
        </div>
      )}
      {!showTitle && (
        <>
          {data?.map((val, i) => {
            const isVal1Active = val?.val1 > val?.val2
            return (
              <div key={i} className={`d-flex ${isColored ? styles.row : ''} align-items-center ${isSmall ? 'py-1' : 'py-2'}`}>
                <div className={`${styles.item}`}>
                  <p
                    className={`${isSmall ? '' : styles.value} ${isVal1Active && isColored && val?.val1 && styles.active} ${
                      isSmall ? '' : 'px-2 py-1 br-xs'
                    }  d-inline-flex mb-0`}
                  >
                    {val?.val1 || '--'}
                  </p>
                </div>
                <p className={`${styles.label} mb-0 fw-bold px-1 text-center`}>{val?.title}</p>
                <div className={`${styles.item} text-end`}>
                  <p
                    className={`${isSmall ? '' : styles.value} ${!isVal1Active && isColored && val?.val2 && styles.active} ${
                      isSmall ? '' : 'px-2 py-1 br-xs'
                    }  d-inline-flex mb-0`}
                  >
                    {val?.val2 || '--'}
                  </p>
                </div>
              </div>
            )
          })}
        </>
      )}
    </div>
  )
}
CompareList.propTypes = {
  // firstPlayer: PropTypes.object,
  // secondPlayer: PropTypes.object,
  data: PropTypes.array,
  isSmall: PropTypes.bool,
  isColored: PropTypes.bool,
  showTitle: PropTypes.bool
}
export default CompareList
